import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBox,
  faBoxOpen,
  faEdit,
  faCube,
  faTag,
  faLayerGroup,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/ui/modal";

const ProductDetails = ({
  isOpen,
  onClose,
  product,
  onEdit,
  canManage = false,
  getTypeName,
  getCategoryName,
}) => {
  if (!product) return null;

  const InfoItem = ({ icon, label, value, highlight = false }) => (
    <div
      className={`flex items-center gap-4 p-3 rounded-lg border transition-all duration-200 ${
        highlight
          ? "bg-blue-50 border-blue-200"
          : "bg-white border-gray-200 hover:border-blue-200 hover:shadow-sm"
      }`}
    >
      <div
        className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
          highlight ? "bg-blue-100" : "bg-gray-100"
        }`}
      >
        <FontAwesomeIcon
          icon={icon}
          className={`h-4 w-4 ${highlight ? "text-blue-600" : "text-gray-500"}`}
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs uppercase tracking-wider text-gray-500 font-medium">
          {label}
        </p>
        <p className="text-sm font-medium text-gray-900 truncate">
          {value || "-"}
        </p>
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Product details"
      maxWidth="sm:max-w-2xl"
      footer={
        <div className="flex flex-col-reverse sm:flex-row justify-end gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="w-full sm:w-auto px-6 border-2 border-orange-700 text-red-600 hover:text-white hover:bg-orange-600 hover:border-none"
          >
            Close
          </Button>
          {canManage && (
            <Button
              onClick={onEdit}
              className="gap-2 w-full sm:w-auto bg-blue-900 text-white px-6 shadow-md hover:shadow-lg transition-all duration-200"
            >
              <FontAwesomeIcon icon={faEdit} className="h-4 w-4" />
              Edit product
            </Button>
          )}
        </div>
      }
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pb-4 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center shadow-lg">
              <FontAwesomeIcon icon={faBox} className="text-white h-7 w-7" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900">
                {product.product_name}
              </h3>
              <div className="flex flex-wrap items-center gap-2 mt-1">
                <Badge
                  variant="outline"
                  className="bg-blue-50 text-blue-700 border-blue-200 text-xs"
                >
                  <FontAwesomeIcon
                    icon={faBoxOpen}
                    className="mr-1.5 h-3 w-3"
                  />
                  {product.package_type}
                </Badge>
                <Badge
                  variant="outline"
                  className="bg-purple-50 text-purple-700 border-purple-200 text-xs"
                >
                  <FontAwesomeIcon icon={faTag} className="mr-1.5 h-3 w-3" />
                  {getTypeName(product)}
                </Badge>
                <Badge
                  variant="outline"
                  className="bg-orange-50 text-orange-700 border-orange-200 text-xs"
                >
                  <FontAwesomeIcon icon={faList} className="mr-1.5 h-3 w-3" />
                  {getCategoryName(product)}
                </Badge>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-center bg-blue-50 px-4 py-2 rounded-lg border border-blue-200">
              <p className="text-[10px] uppercase tracking-wider text-blue-600 font-semibold">
                Items
              </p>
              <p className="text-xl font-bold text-blue-700">
                {product.no_of_items}
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <InfoItem
            icon={faBox}
            label="Package Type"
            value={product.package_type}
            highlight={true}
          />
          <InfoItem
            icon={faLayerGroup}
            label="Product Type"
            value={getTypeName(product)}
          />
          <InfoItem
            icon={faList}
            label="Category"
            value={getCategoryName(product)}
          />
          <InfoItem
            icon={faCube}
            label="No of products"
            value={product.no_of_items}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ProductDetails;
